import { Shape, SubTitle, Flex, Checkbox, Body, Caption, styled } from '@teko/ds-desktop';
import { DownOutlined, UpOutlined } from '@teko/ds-icon';
import React, { useState } from 'react';
import { t } from '../../i18n.es.js';

const DefaultExpandToggle = ({ expanded, onClick }) => expanded ? /* @__PURE__ */ React.createElement(UpOutlined, {
  onClick,
  style: { cursor: "pointer" }
}) : /* @__PURE__ */ React.createElement(DownOutlined, {
  onClick,
  style: { cursor: "pointer" }
});
const DEFAULT_DISPLAY_FILTERS = 4;
const CategoriesFilter = (props) => {
  const {
    filterName,
    filterOptions,
    activeOptions,
    onClickCategoryOption,
    renderExpandIcon,
    collapsible = false
  } = props;
  const [numberOfDisplayFilters, setNumberOfDisplayFilters] = useState(DEFAULT_DISPLAY_FILTERS);
  const [expanded, setExpanded] = useState(true);
  const activeCats = new Set(activeOptions.map(({ code }) => code));
  const checkChildren = (root) => {
    if (!root.children.length)
      return;
    root.children.forEach((child) => {
      if (!!child.code && !!root.code && activeCats.has(root.code)) {
        activeCats.add(child.code);
      }
      checkChildren(child);
    });
  };
  filterOptions.forEach(checkChildren);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Shape, {
    height: "1.5rem"
  }, collapsible ? /* @__PURE__ */ React.createElement(HeaderRow, {
    onClick: () => setExpanded((prev) => !prev)
  }, /* @__PURE__ */ React.createElement(SubTitle, {
    level: 4,
    weight: "medium"
  }, filterName), /* @__PURE__ */ React.createElement(CollapseChevron, {
    className: expanded ? "expanded" : ""
  })) : /* @__PURE__ */ React.createElement(SubTitle, {
    level: 4,
    weight: "medium"
  }, filterName)), (!collapsible || expanded) && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Flex, {
    direction: "column",
    gap: "s4",
    style: { padding: collapsible ? "12px 0px 2px" : "2px 0px" }
  }, filterOptions.slice(0, numberOfDisplayFilters).map((option, index) => {
    return /* @__PURE__ */ React.createElement(Filter, {
      key: `${index}${option.id}${option.code}`,
      option,
      onClickCategoryOption,
      activeCats,
      renderExpandIcon,
      regularWeight: collapsible
    });
  })), filterOptions.length > DEFAULT_DISPLAY_FILTERS && /* @__PURE__ */ React.createElement(ViewAll, {
    onClick: () => setNumberOfDisplayFilters(numberOfDisplayFilters > DEFAULT_DISPLAY_FILTERS ? DEFAULT_DISPLAY_FILTERS : filterOptions.length)
  }, t(numberOfDisplayFilters > DEFAULT_DISPLAY_FILTERS ? "\u1EA8n b\u1EDBt" : "Xem th\xEAm"))));
};
const hasActiveDescendant = (option, activeCats) => option.children.some((child) => !!child.code && activeCats.has(child.code) || hasActiveDescendant(child, activeCats));
const Filter = (props) => {
  const {
    option,
    activeCats,
    onClickCategoryOption,
    renderExpandIcon,
    regularWeight
  } = props;
  const [showChildren, setShowChildren] = useState(false);
  const checked = !!option.code && activeCats.has(option.code);
  const indeterminate = !checked && hasActiveDescendant(option, activeCats);
  const toggle = () => setShowChildren((prev) => !prev);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Flex, {
    justify: "space-between",
    width: "100%",
    style: { padding: "2px 0" }
  }, /* @__PURE__ */ React.createElement(Checkbox, {
    checked,
    partSelected: indeterminate,
    onChange: (_check) => onClickCategoryOption == null ? void 0 : onClickCategoryOption(option)
  }, option.level === 1 ? /* @__PURE__ */ React.createElement(Body, {
    line: 1,
    weight: regularWeight ? "regular" : void 0
  }, option.name) : option.level === 2 ? option.name : /* @__PURE__ */ React.createElement(Caption, {
    line: 1,
    level: 1
  }, option.name)), !!option.children.length && (renderExpandIcon ? renderExpandIcon(showChildren, toggle) : /* @__PURE__ */ React.createElement(DefaultExpandToggle, {
    expanded: showChildren,
    onClick: toggle
  }))), !!option.children.length && showChildren && /* @__PURE__ */ React.createElement(Flex, {
    direction: "column",
    gap: "s4",
    paddingLeft: "s24",
    width: "100%"
  }, option.children.map((child, index) => {
    return /* @__PURE__ */ React.createElement(Filter, {
      key: `${index}${child.id}${child.code}`,
      option: child,
      onClickCategoryOption,
      activeCats,
      renderExpandIcon,
      regularWeight
    });
  })));
};
const ViewAll = styled.span(({ theme }) => `
  color: ${theme == null ? void 0 : theme.colors.link500};
  cursor: pointer;
  font-size: 0.75rem;
  margin-left: 1.7rem;
`);
const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
  user-select: none;
`;
const CollapseChevron = styled(DownOutlined)`
  transition: transform 0.2s;
  &.expanded {
    transform: rotate(180deg);
  }
`;

export { CategoriesFilter };
